export function formatMoney(amount: number): string {
  if (amount >= 1_000_000) {
    return `$${(amount / 1_000_000).toFixed(1).replace(/\.0$/, '')}M`
  }
  if (amount >= 1_000) {
    return `$${Math.round(amount / 1_000)}K`
  }
  return `$${Math.round(amount)}`
}

export function formatMoneyRange(low: number, high: number): string {
  return `${formatMoney(low)} – ${formatMoney(high)}`
}

export function formatPct(n: number): string {
  return `${n.toFixed(1).replace(/\.0$/, '')}%`
}

export function formatInt(n: number): string {
  return n.toLocaleString('en-US')
}
